import {Box, Tooltip} from "@mui/material";
import React, {createElement} from "react";
import WarningIcon from "@mui/icons-material/Warning";
import {KeyProblemOption} from "../../api/KeyProblemStore";
import {SvgIconProps} from "@mui/material/SvgIcon/SvgIcon";


export function KeyProblemIcon({problem, ...props}: {
    problem?: KeyProblemOption,
} & SvgIconProps) {
    return problem ? (
        <Tooltip title={problem.label}>
            {createElement(problem.icon || WarningIcon, {
                color: 'warning',
                fontSize: "small",
                ...props,
            })}
        </Tooltip>
    ) : (
        <Box sx={{width: '20px'}}>&nbsp;</Box>
    );
}